/**
 * Service Worker 등록 및 관리
 */

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
      const isDevelopment = process.env.NODE_ENV === 'development';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // Service Worker 등록은 중요한 이벤트이므로 항상 로그 출력
          console.log('[Service Worker] 등록 성공:', registration.scope, {
            state: registration.active?.state || 'installing',
            hostname: window.location.hostname
          });

          // Service Worker가 활성화되면 인증 토큰 전달
          if (registration.active) {
            sendAuthTokenToServiceWorker();
          }

          // Service Worker 메시지 리스너 설정
          setupServiceWorkerMessageListener();

          // 업데이트 확인
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  if (isDevelopment) {
                    console.log('[Service Worker] 새 버전 사용 가능');
                  }
                  // 새 버전 활성화 시 토큰 재전달
                  sendAuthTokenToServiceWorker();
                }
              });
            }
          });
        })
        .catch((error) => {
          // Service Worker 등록 실패는 중요한 에러이므로 항상 로그 출력
          console.error('[Service Worker] 등록 실패:', error, {
            url: swUrl,
            hostname: window.location.hostname,
            protocol: window.location.protocol
          });
        });

      // 주기적 백그라운드 동기화 등록
      if ('sync' in window.ServiceWorkerRegistration.prototype) {
        navigator.serviceWorker.ready.then((registration) => {
          // 1분마다 백그라운드 동기화 요청
          setInterval(() => {
            registration.sync
              .register('check-daily-time-notification')
              .then(() => {
                // 개발 환경에서만 로그 출력
                if (isDevelopment) {
                  console.log('[Service Worker] 백그라운드 동기화 등록됨');
                }
              })
              .catch((err) => {
                if (isDevelopment) {
                  console.error('[Service Worker] 백그라운드 동기화 등록 실패:', err);
                }
              });
          }, 60000); // 1분
        });
      }
    });
  } else {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Service Worker] 이 브라우저는 Service Worker를 지원하지 않습니다.');
    }
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}

// Service Worker에 메시지 전송
export function sendMessageToServiceWorker(message) {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(message);
  }
}

// Service Worker에 인증 토큰 전달
export function sendAuthTokenToServiceWorker() {
  const token = localStorage.getItem('token');
  if (token && 'serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SET_AUTH_TOKEN',
      token: token,
    });
    // 인증 토큰 전달은 중요한 이벤트이므로 항상 로그 출력 (토큰 값은 제외)
    if (process.env.NODE_ENV === 'development') {
      console.log('[Service Worker] 인증 토큰 전달됨');
    }
  } else {
    // 토큰이 없거나 Service Worker가 없는 경우 경고 (개발 환경에서만 출력)
    if (process.env.NODE_ENV === 'development') {
      if (!token) {
        console.warn('[Service Worker] 인증 토큰이 없어 전달할 수 없습니다.');
      }
      if (!navigator.serviceWorker.controller) {
        // 초기 로딩 시에는 정상적인 상황일 수 있음
        console.log('[Service Worker] Service Worker 컨트롤러가 아직 준비되지 않았습니다. (초기 로딩 중일 수 있음)');
      }
    }
  }
}

// Service Worker 메시지 수신 처리
export function setupServiceWorkerMessageListener() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'REQUEST_AUTH_TOKEN') {
        // Service Worker가 토큰을 요청하면 전달
        sendAuthTokenToServiceWorker();
      }
    });
  }
}

